import arrayMutators from "final-form-arrays";
import { get } from "lodash";
import React from "react";
import { Form } from "react-final-form";
import "react-quill/dist/quill.snow.css";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Col, Row, Spinner } from "reactstrap";
import AppBar from "src/components/AppBar/AppBar";
import { Container } from "src/components/Container/Container";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import { IconName } from "src/components/Icon/Icon";
import { defaultDncPhone, IIODncPhone } from "src/store/models/campaignDncPhone.models";
import Toast from "../../components/Toast/Toast";
import * as S from "../../constants/StringConstants";
import { IRootState } from "../../store/reducers";
import {
  addDncPhone,
  fetchDncPhone,
  hideErrorToastDncPhone,
  updateDncPhone,
} from "../../store/reducers/campaignDncPhone";
import "../CampaignDncEmailBuilder/CampaignDncEmailBuilder.scss";

const validate = (name: string, values: any) => {
  const errors: any = {};
  if (name === "phoneNumber" && !values.phone) {
    errors["phone"] = S.DNC_PHONE_REQUIRED;
  }
  return errors;
};

interface ICampaignDncEmailBuilderProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

class CampaignDncPhoneBuilder extends React.Component<ICampaignDncEmailBuilderProps> {
  constructor(props) {
    super(props);
  }

  dncPhoneToFormValues = (dncPhone: any): IIODncPhone => {
    const phoneNumber = get(dncPhone, "phoneNumber");
    const id = get(dncPhone, "id");
    const lastUpdatedDate = get(dncPhone, "lastUpdatedDate");
    const userId = get(dncPhone, "userId");
    return {
      id,
      phoneNumber,
      lastUpdatedDate,
      userId,
    };
  };

  handleSubmit = async (values: any) => {
    const dncPhoneId = get(this.props.match.params, "id", "new");
    const isNew = dncPhoneId === "new";

    const payload = {
      ...values,
      userId: this.props.user.userID,
    };
    if (isNew) {
      await this.props.addDncPhone([payload]);
    } else {
      await this.props.updateDncPhone(payload);
    }
    this.props.history.push("/dnc/phone/all");
  };

  componentDidMount() {
    const id = this.dncPhoneId;
    if (id) {
      this.props.fetchDncPhone(id.toString());
    }
  }

  get dncPhone() {
    if (this.dncPhoneId) {
      return this.props.dncPhone.map[this.dncPhoneId];
    } else {
      return null;
    }
  }

  get dncPhoneId() {
    const id = parseInt(this.props.match.params.id, 10);
    return id && !isNaN(id) ? id : null;
  }

  render() {
    const { dncPhone, hideErrorToastDncPhone, match } = this.props;
    const dncPhoneId = get(match.params, "id", "new");
    const isNew = dncPhoneId === "new";
    const initialValues = this.dncPhone ? this.dncPhoneToFormValues(this.dncPhone) : defaultDncPhone;

    return (
      <>
        <div className="campaignDnc-builder">
          <AppBar icon={IconName.Campaigns} title={isNew ? S.DNC_PHONE_NEW : S.DNC_PHONE_EXISTING} />

          <div className="campaignDnc-builder__form">
            <section className="campaignDnc-builder__wrap">
              <div className="campaignDnc-builder__container">
                <Container>
                  <Form
                    validate={validate.bind(null, "steps")}
                    onSubmit={this.handleSubmit}
                    initialValues={initialValues}
                    mutators={{
                      ...arrayMutators,
                    }}
                    render={({ values, valid, handleSubmit, form }) => {
                      return (
                        <form onSubmit={handleSubmit}>
                          <Row>
                            <TextField name="phoneNumber" key="phoneNumber" label={S.DNC_PHONE_LABEL} />
                          </Row>
                          <Row>
                            <Col>
                              <div className="campaignDnc-builder__top-bar">
                                <div className="buttons">
                                  <ul>
                                    <li>
                                      <button
                                        className="button-v2 button-v2__primary"
                                        type="submit"
                                        disabled={this.props.dncPhone.loading || !valid}>
                                        {this.props.dncPhone.loading ? <Spinner color="light" /> : S.TPL_SUBMIT_BUTTON}
                                      </button>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </form>
                      );
                    }}
                  />
                </Container>
              </div>
            </section>
            <aside></aside>
          </div>
        </div>

        <Toast message={S.LOADING} onClose={() => {}} open={this.props.dncPhone.loading} />
        <Toast
          message={dncPhone.errorMessage}
          onClose={() => {
            hideErrorToastDncPhone();
          }}
          open={dncPhone.error}
        />
      </>
    );
  }
}

const mapStateToProps = ({ dncPhone, auth }: IRootState) => ({
  dncPhone,
  user: auth.user,
});

const mapDispatchToProps = {
  addDncPhone,
  updateDncPhone,
  fetchDncPhone,
  hideErrorToastDncPhone,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CampaignDncPhoneBuilder));
